'use client'
import Link from 'next/link'
import { Pillow } from '@/components/Pillow/Pillow'
import { type LinkField, type SbBaseBlockProps, type StoryblokAsset } from '@/services/storyblok/storyblok'
import { getImgSrc, getLinkFieldURL } from '@/services/storyblok/Storyblok.helpers'
import { Button } from 'ui/src/components/Button/Button'
import { Card } from 'ui/src/components/Card/Card'
import { xStack } from 'ui/src/patterns/stack'
import { button, cardContent } from './CardLinkSmallBlock.css'

type Props = SbBaseBlockProps<{
  title: string
  subtitle?: string
  pillow?: StoryblokAsset
  link: LinkField
  buttonLabel?: string
}>

export function CardLinkSmallBlock({ blok }: Props) {
  const { title, subtitle, pillow, link, buttonLabel } = blok

  return (
    <Link aria-label={title} href={getLinkFieldURL(link)}>
      <Card.Root variant="primary" size="lg" className={cardContent}>
        <div className={xStack({ justifyContent: 'space-between' })}>
          <Card.Header>
            {pillow && (
              <Card.Media>
                <Pillow src={getImgSrc(pillow.filename)} size="small" />
              </Card.Media>
            )}

            <Card.Heading>
              <Card.Title>{title}</Card.Title>
              {subtitle && <Card.Subtitle>{subtitle}</Card.Subtitle>}
            </Card.Heading>
          </Card.Header>

          {buttonLabel && (
            <Button aria-hidden="true" as="span" variant="secondary" className={button}>
              {buttonLabel}
            </Button>
          )}
        </div>
      </Card.Root>
    </Link>
  )
}
